import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getAuthState } from '@/stores/auth.store';

export const Route = createFileRoute('/_account-setup')({
  beforeLoad: async ({ location }) => {
    const { isAuthenticated, accessToken, user } = getAuthState();

    if (!isAuthenticated || !accessToken) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }

    // Redirect to dashboard if account setup is already complete
    if (user?.accountSetupComplete) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: AccountSetupLayout,
});

function AccountSetupLayout() {
  // No AppLayout wrapper - just render the outlet directly
  return <Outlet />;
}
